function AvatarIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={20} cy={20} r={20} fill="#F8F8F8" />
      <path
        d="M20 12a4 4 0 110 8 4 4 0 010-8zm0 10c4.42 0 8 1.79 8 4v2H12v-2c0-2.21 3.58-4 8-4z"
        fill="#B4B4B4"
      />
    </svg>
  )
}

export default AvatarIcon
